
import dashboardGridConfig from "./dashboard.grid";
import acessoGridConfig from "./acesso.grid";
import acessoregraGridConfig from "./acessoregra.grid";
import permissaoGridConfig from "./permissao.grid";
import pacoteGridConfig from "./pacote.grid";
import agendamentoGridConfig from "./agendamento.grid";
import avisoGridConfig from "./aviso.grid";
import cadastroGridConfig from "./cadastro.grid";
import cancelamentoGridConfig from "./cancelamentos.grid";
import compraGridConfig from "./compra.grid";
import compraitemGridConfig from "./compraitem.grid";
import despesaGridConfig from "./despesa.grid";
import despesaitemGridConfig from "./despesaitem.grid";
import despesacategoriaGridConfig from "./despesacategoria.grid";
import especialidadeGridConfig from "./especialidade.grid";
import estoqueGridConfig from "./estoque.grid";
import faltaGridConfig from "./falta.grid";
import formapagtoGridConfig from "./formapagto.grid";
import fornecedorGridConfig from "./fornecedor.grid";
import fornecedorcategoriaGridConfig from "./fornecedorcategoria.grid";
import horarioGridConfig from "./horario.grid";
import horariofechamentoGridConfig from "./horariofechamento.grid";
import metaGridConfig from "./meta.grid";
import produtoGridConfig from "./produto.grid";
import produtovendaGridConfig from "./produtovenda.grid";
import receitaGridConfig from "./receita.grid";
import vendaGridConfig from "./venda.grid";
import ConfiguracoesGridConfig from "./configuracoes.grid";
import DadosSistemaGridConfig from "./dadossistema.grid";

export const gridConfigMap = {
  dashboard: dashboardGridConfig,
  acessos: acessoGridConfig,
  acessosregras: acessoregraGridConfig,
  permissao: permissaoGridConfig,
  pacotes: pacoteGridConfig,
  agendamentos: agendamentoGridConfig,
  avisos: avisoGridConfig,
  cadastros: cadastroGridConfig,
  cancelamentos: cancelamentoGridConfig,
  compras: compraGridConfig, 
  compraitens: compraitemGridConfig, 
  despesas: despesaGridConfig, 
  despesasitens: despesaitemGridConfig, 
  despesascategorias: despesacategoriaGridConfig, 
  especialidades:especialidadeGridConfig,
  estoque: estoqueGridConfig,
  faltas:faltaGridConfig, 
  formapagto: formapagtoGridConfig, 
  fornecedores: fornecedorGridConfig, 
  fornecedorescategorias: fornecedorcategoriaGridConfig, 
  horarios: horarioGridConfig, 
  horariosfechamento: horariofechamentoGridConfig, 
  metas: metaGridConfig,
  produtos:produtoGridConfig, 
  produtosvendas: produtovendaGridConfig, 
  receitas: receitaGridConfig, 
  vendas: vendaGridConfig,
  configuracoes: ConfiguracoesGridConfig,
  dados:DadosSistemaGridConfig
};

